import React from 'react';

type Props = {
  title?: string;
  description?: string;
  link?: string;
};

const JoinNowSection = ({
  title = 'Join and Get A Free Trial Period For You',
  description = "Don't Miss Out On Our Special Offers, Try It Now Before It Start To Run Out",
  link = 'https://otc.gunthy.org/gunthar/trial',
}: Props) => {
  return (
    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div
              className="px-md-5 px-3 pt-5 z-index-1 shadow overflow-hidden"
              style={{ backgroundColor: 'rgba(30, 80, 255, 0.02)' }}
            >
              <div className="row align-items-end">
                <div className="col-lg-8 col-xl-6 mb-6">
                  <div className="mb-3 position-relative">
                    <h2>{title}</h2>
                    <span className="title-shadow"></span>
                  </div>
                  <p className="lead mb-4">{description}</p>
                  <a href={link} className="btn btn-primary" target="_blank" rel="noreferrer">
                    Join Now
                  </a>
                </div>
                <div className="col-lg-4 col-xl-6 text-end">
                  <img className="img-fluid mb-n4" src="/images/join.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinNowSection;
